import { jsxs as x, jsx as t } from "react/jsx-runtime";
import * as d from "@radix-ui/react-menu";
import { useControllableState as y } from "@radix-ui/react-use-controllable-state";
import { RefToTgphRef as g } from "@telegraph/helpers";
import { Stack as C, Box as v } from "@telegraph/layout";
import I from "react";
import { Button as m } from "@telegraph/button";
import { Lucide as O } from "@telegraph/icon";
import { motion as R } from "@telegraph/motion";
const B = ({
  variant: n = "ghost",
  size: e = "2",
  h: r = "7",
  gap: o = "3",
  justify: i = "space-between",
  w: a = "auto",
  selected: c,
  icon: u,
  leadingIcon: l,
  leadingComponent: s,
  trailingIcon: f,
  trailingComponent: h,
  ...p
}) => /* @__PURE__ */ x(
  m.Root,
  {
    size: e,
    variant: n,
    h: r,
    gap: o,
    justify: i,
    w: a,
    ...p,
    children: [
      /* @__PURE__ */ x(C, { gap: o, align: "center", w: "full", children: [
        /* @__PURE__ */ t(
          M,
          {
            icon: u,
            selected: c,
            leadingIcon: l,
            leadingComponent: s
          }
        ),
        /* @__PURE__ */ t(m.Text, { weight: "regular", children: p.children })
      ] }),
      /* @__PURE__ */ t(
        S,
        {
          trailingIcon: f,
          trailingComponent: h
        }
      )
    ]
  }
), M = ({
  icon: n,
  selected: e,
  leadingIcon: r,
  leadingComponent: o
}) => {
  if (e === !0 || e === !1)
    return /* @__PURE__ */ t(
      m.Icon,
      {
        as: R.span,
        variant: "primary",
        icon: O.Check,
        "aria-hidden": !0,
        initializeWithAnimation: !1,
        animate: e ? {
          opacity: 1,
          rotate: 0,
          scale: 1
        } : {
          opacity: 0,
          rotate: -45,
          scale: 0.3
        },
        transition: { duration: 150, type: "spring" },
        style: { transformOrigin: "center" }
      }
    );
  const a = r || n;
  if (a)
    return /* @__PURE__ */ t(m.Icon, { variant: "primary", ...a });
  if (o)
    return o;
}, S = ({
  trailingIcon: n,
  trailingComponent: e
}) => {
  if (n)
    return /* @__PURE__ */ t(m.Icon, { variant: "primary", ...n });
  if (e)
    return e;
}, b = I.createContext({
  open: !1,
  setOpen: () => {
  }
}), T = ({
  open: n,
  onOpenChange: e,
  defaultOpen: r,
  modal: o = !0,
  children: i,
  ...a
}) => {
  const [c = !1, u] = y({
    prop: n,
    defaultProp: r,
    onChange: e
  });
  return /* @__PURE__ */ t(b.Provider, { value: { open: c, setOpen: u }, children: /* @__PURE__ */ t(
    d.Root,
    {
      open: c,
      onOpenChange: u,
      modal: o,
      ...a,
      children: i
    }
  ) });
}, k = ({ asChild: n = !0, tgphRef: e, children: r, ...o }) => {
  const i = I.useContext(b);
  return /* @__PURE__ */ t(
    d.Anchor,
    {
      onClick: () => {
        i.setOpen(!i.open);
      },
      asChild: n,
      ...o,
      ref: e,
      children: /* @__PURE__ */ t(g, { children: r })
    }
  );
}, w = ({
  direction: n = "column",
  gap: e = "1",
  rounded: r = "4",
  py: o = "1",
  border: i = "px",
  shadow: a = "2",
  sideOffset: c = 4,
  children: u,
  onInteractOutside: l,
  onKeyDown: s,
  onCloseAutoFocus: f,
  tgphRef: h,
  ...p
}) => /* @__PURE__ */ t(
  d.Content,
  {
    onInteractOutside: l,
    onKeyDown: s,
    onCloseAutoFocus: f,
    asChild: !0,
    sideOffset: c,
    ...p,
    ref: h,
    children: /* @__PURE__ */ t(g, { children: /* @__PURE__ */ t(
      C,
      {
        bg: "surface-1",
        direction: n,
        gap: e,
        rounded: r,
        border: i,
        py: o,
        shadow: a,
        style: {
          overflowY: "auto"
        },
        zIndex: "popover",
        children: u
      }
    ) })
  }
), L = ({
  mx: n = "1",
  asChild: e = !0,
  icon: r,
  leadingIcon: o,
  trailingIcon: i,
  leadingComponent: a,
  trailingComponent: c,
  selected: u,
  tgphRef: l,
  ...s
}) => {
  const f = o || r;
  return /* @__PURE__ */ t(d.Item, { ...s, asChild: e, ref: l, children: /* @__PURE__ */ t(g, { children: /* @__PURE__ */ t(
    B,
    {
      selected: u,
      leadingIcon: f,
      trailingIcon: i,
      leadingComponent: a,
      trailingComponent: c,
      "data-tgph-menu-button": !0,
      mx: n,
      style: {
        flexShrink: 0
      },
      ...s
    }
  ) }) });
}, j = ({
  w: n = "full",
  borderBottom: e = "px",
  ...r
}) => /* @__PURE__ */ t(v, { as: "hr", w: n, borderBottom: e, ...r }), z = {};
Object.assign(z, {
  Root: T,
  Trigger: k,
  Content: w,
  Button: L,
  Divider: j
});
export {
  z as Menu,
  B as MenuItem
};
//# sourceMappingURL=index.mjs.map
